module.exports = __webpack_public_path__ + "img/op_img-carrusel-personas-mobile.4aac7ef.jpg";